import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "helpers/jwt-token-access/customBaseQuery";

export const dashboardSlice = createApi({
  reducerPath: "dashboard",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getDashboardSummary: builder.query({
      query: () => "/dashboard/v1/admin-dashboard-summary/",
    }),
    getReportSummary: builder.query({
      query: () => "/dashboard/v1/admin-report-summary/",
    }),
    getToolBoxSummary: builder.query({
      query: () => "/dashboard/v1/admin-toolbox-summary/",
    }),
    getProcurementDashboardSummary: builder.query({
      query: (projectIds: number[] = []) => {
        const query = projectIds.length
          ? `?project_ids=${encodeURIComponent(projectIds.join(","))}`
          : "";
        return `/dashboard/v1/procurement-dashboard-summary/${query}`;
      },
    }),
  }),
});

export const {
  useGetDashboardSummaryQuery,
  useGetReportSummaryQuery,
  useGetToolBoxSummaryQuery,
  useGetProcurementDashboardSummaryQuery,
} = dashboardSlice;
